import TokensApi from '../../core/api/TokensApi'
export const FETCHED_TOKEN_VERIFICATION = 'FETCHED_TOKEN_VERIFICATION'
export const FETCHING_TOKEN_VERIFICATION = 'FETCHING_TOKEN_VERIFICATION'

export const fetchingTokenVerification = (token) => ({
  type: FETCHING_TOKEN_VERIFICATION,
  token
})

export function fetchTokenVerification (token) {
  const api = new TokensApi()
  const request = api.verifyToken(token)

  return (dispatch) => {
    dispatch(fetchingTokenVerification(token))
    request.then(function (response) {
      dispatch(api.handleResponse(FETCHED_TOKEN_VERIFICATION, response))
    })
  }
}
